<template>
  <!-- 线上精品课 -->
  <div class="onlineCourse">
    <div class="onlineCon">
      <div class="talentTitle" style="margin-top:18px">
        <div class="mainTitle">
          线上精品课程
          <slot name="subTitle">
          </slot>
        </div>
        <div class="box-con" >
          <div class="box-con-btn" :class="curIndex === '' ? 'btn-select' : 'btn-normal'" @click="clickCourse('')">
            全部
          </div>
          <div class="box-con-btn" :class="curIndex === item.subjectId ? 'btn-select' : 'btn-normal'"
            v-for="item in onlineTypeList" :key="item.subjectId" @click="clickCourse(item.subjectId)">
            {{ item.subjectName }}
          </div>
        </div>
      </div>
      <div class="wow animate__animated animate__slideInLeft courseCon">
        <div v-for="(item, index) in courseList" :key="index" class="courseItem" @click="onClickDetail(item)">
          <div class="courseItem-top">
            <div class="courseItem-top-bg" :style="{
              backgroundImage: `url(https://static.zhuzaocloud.com/${item.logo})`,
            }"></div>
            <div class="courseItem-top-title over-num-lines num2-lines" :title="item.courseName">{{ item.courseName }}</div>
          </div>
          <div class="courseItem-bottom">
            <div class="courseItem-bottom-num">
              <i class="el-icon-view iconView" />{{ item.viewcount }}
            </div>
            <!--￥{{ item.sourceprice }} -->
            <div class="courseItem-bottom-price">免费</div>
          </div>
        </div>
      </div>
      <div class="curp" @click="onClickCourseMore">
        更多课程
      </div>
    </div>
  </div>
</template>

<script>
import { getCourseList, getCourseType } from "../../utils/interface"
export default {
  name: "",
  props: {},
  data() {
    return {
      onlineTypeList: [
        { subjectName: "数字化转型", subjectId: "1" },
        { subjectName: "智能制造", subjectId: "2" },
        { subjectName: "生产管理", subjectId: "3" },
        { subjectName: "安全教育", subjectId: "4" },
        { subjectName: "经营管理", subjectId: "5" },
      ],
      curIndex: "", //当前位置
      courseList: [
        {
          logo: require("../../assets/publicService/talentService/55.png"),
          courseName: "金属材料的力学性能的力学性能",
          viewcount: 24455,
          sourceprice: 199,
        },
      ],
    }
  },
  watch: {},
  computed: {},
  created() { },
  mounted() {
    this.getCourseType()
    this.getCourseList("")
  },
  methods: {
    // 获取线上精品课程分类
    getCourseType() {
      getCourseType().then((res) => {
        if (res.data && res.data.length > 0) {
          this.onlineTypeList = res.data
        } else {
          this.onlineTypeList = []
        }
      })
    },
    // 线上精品课程-查看更多
    onClickCourseMore() {
      let route = this.$router.resolve({
        path: "/onlineCourseList",
      })
      window.open(route.href, "_blank")
    },
    // 直播公开课详情
    onClickDetail(item) {
      let routeData = this.$router.resolve({
        path: "/onlineCourseDetail",
        query: {
          courseId: item.courseId,
          type: "course",
          titleName: "在线精品课程详情",
          titleForm: "onlineCourseDetail",
        },
      })
      window.open(routeData.href, "_blank")
    },
    // 点击课程分类
    clickCourse(subjectId) {
      this.curIndex = subjectId
      this.getCourseList(subjectId)
    },
    // 根据课程分类id获取课程列表
    getCourseList(subjectId) {
      getCourseList({
        current: "1",
        pageSize: "8",
        subjectId: subjectId,
        courseName: "",
      }).then((res) => {
        if (res.list && res.list.length > 0) {
          console.log("courseList", res.list)
          this.courseList = res.list
        } else {
          this.courseList = []
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.talentTitle {
  padding: 4px 10px;

  .mainTitle {
    margin-bottom: 25px;
    font-size: 24px;
    font-weight: bold;
    line-height: normal;
    color: #2B2B2B;
    text-align: center;
  }
}
.onlineCourse {
  background-color: #F0F4FA;

  .curp {
    margin: 0 auto 35px;
    width:200px;
    height: 50px;
    border-radius: 4px;
    cursor: pointer;
    opacity: 1;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #2D50A1; 
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    color: #2D50A1;
    &:hover {
      color: #2d50a1;
    }
  }

  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .num2-lines {
    -webkit-line-clamp: 2;
  }

  .onlineCon {
    width: 1300px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    justify-items: center;

    .box-con {
      padding-bottom: 26px;
      display: flex;
      flex-flow: row wrap;
      font-size: 18px;
      font-weight: 350;
      letter-spacing: 0;
      overflow: hidden;
      border-bottom: 1px solid #CBCBCB;

      .box-con-btn {
        margin-left: 14px;
        border-radius: 302px;
        height: 35px;
        padding: 4px 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:first-of-type {
          margin-left: 0;
        }
      }

      .btn-normal {
        color: #959595;
        background-color: #E5E5E5;
      }

      .btn-select {
        color: #2D50A1;
        background-color: #E0EBFF;
      }
    }

    .courseCon {
      margin: 24px 0 10px;
      width: 100%;
      display: flex;
      flex-flow: row wrap;
      // justify-content: space-between;
      // align-items: center;

      .courseItem {
        width: 312px;
        height: 312px;
        padding: 17px 14px;
        border-radius: 8px;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        // border: 1px solid #efefef;
        box-sizing: border-box;
        background-color: #fff;
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;
        transition: all 0.2s;
        margin-right: 17px;
        margin-bottom: 22px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:hover {
          transform: scale(1.02);
          cursor: pointer;
        }

        .courseItem-top {
          .courseItem-top-bg {
            width: 285px;
            height: 182px;
            background-repeat: no-repeat;
            // background-size: 100% 100%;
            background-size: 100% 100%;
            border-radius: 4px;
            
          }

          .courseItem-top-title {
            margin: 9px 0;
            font-size: 21px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: 0em;
          }
        }

        .courseItem-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 18px;
          font-weight: 350;
          padding: 4px 10px 8px;
          .courseItem-bottom-num {
            color: #2B2B2B;

            .iconView {
              margin-right: 3px;
            }
          }

          .courseItem-bottom-price {
            color: #2D50A1;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/talentServices/onlineCourse2.vue